var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.elementType,_vm._b({tag:"component",class:[
    _vm.$style.section,
    {
      [_vm.$style['section--disabled']]: _vm.disabled,
      [_vm.$style['section--hidden-disabled-mobile']]: _vm.hiddenDisabledMobile && _vm.disabled,
    },
  ]},'component',{ ..._vm.$props, ..._vm.$listeners },false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }